var _path, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSurveyFull(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 171,
    height: 115,
    viewBox: "0 0 171 115",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M171 0H0V115H171V0Z",
    fill: "#485bff",
    fillOpacity: 0.15
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 20,
    width: 108,
    height: 74,
    rx: 8,
    fill: "#485bff"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 49,
    width: 73,
    height: 5,
    rx: 2.5,
    fill: "white",
    fillOpacity: 0.5
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 56,
    width: 76,
    height: 5,
    rx: 2.5,
    fill: "white",
    fillOpacity: 0.5
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 42,
    width: 78,
    height: 5,
    rx: 2.5,
    fill: "white",
    fillOpacity: 0.5
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 32,
    width: 54,
    height: 5,
    rx: 2.5,
    fill: "white",
    fillOpacity: 0.8
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 67,
    width: 15.6418,
    height: 13.8758,
    rx: 2.36004,
    fill: "white",
    fillOpacity: 0.28
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 60.8832,
    y: 67,
    width: 15.3935,
    height: 13.8758,
    rx: 2.36004,
    fill: "white",
    fillOpacity: 0.28
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 77.5181,
    y: 67,
    width: 15.8901,
    height: 13.8758,
    rx: 2.36004,
    fill: "white",
    fillOpacity: 0.28
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 94.6496,
    y: 67,
    width: 15.3935,
    height: 13.8758,
    rx: 2.36004,
    fill: "white",
    fillOpacity: 0.28
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 111.478,
    y: 67.132,
    width: 15.6418,
    height: 13.8758,
    rx: 2.36004,
    fill: "white",
    fillOpacity: 0.28
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M52.7465 71.4206V76.5697H51.6578V72.4539H51.6276L50.4484 73.1931V72.2276L51.7232 71.4206H52.7465Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M119.315 76.7722C118.96 76.7722 118.643 76.7068 118.365 76.5761C118.088 76.4453 117.869 76.2651 117.706 76.0355C117.544 75.8059 117.459 75.5427 117.452 75.246H118.508C118.52 75.4455 118.604 75.6073 118.76 75.7313C118.916 75.8553 119.101 75.9173 119.315 75.9173C119.486 75.9173 119.637 75.8796 119.768 75.8042C119.9 75.7271 120.003 75.6207 120.077 75.4849C120.153 75.3474 120.19 75.1899 120.19 75.0122C120.19 74.8312 120.152 74.672 120.075 74.5345C119.999 74.3971 119.894 74.2898 119.76 74.2127C119.626 74.1356 119.473 74.0962 119.3 74.0945C119.149 74.0945 119.003 74.1255 118.86 74.1875C118.719 74.2496 118.61 74.3342 118.531 74.4415L117.563 74.268L117.807 71.5526H120.955V72.4427H118.704L118.571 73.7325H118.601C118.692 73.6051 118.828 73.4995 119.011 73.4157C119.194 73.3319 119.398 73.29 119.625 73.29C119.935 73.29 120.211 73.3629 120.454 73.5087C120.697 73.6545 120.889 73.8548 121.03 74.1096C121.171 74.3627 121.24 74.6544 121.239 74.9846C121.24 75.3315 121.16 75.6399 120.997 75.9098C120.836 76.178 120.611 76.3892 120.321 76.5434C120.033 76.6959 119.697 76.7722 119.315 76.7722Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M100.292 75.7317V74.8743L102.442 71.4876H103.181V72.6744H102.743L101.388 74.819V74.8593H104.443V75.7317H100.292ZM102.763 76.6368V75.4702L102.783 75.0906V71.4876H103.804V76.6368H102.763Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M85.4503 76.6401C85.0748 76.6401 84.7404 76.5756 84.4471 76.4465C84.1555 76.3158 83.925 76.1365 83.7557 75.9085C83.5881 75.6789 83.5017 75.414 83.4967 75.114H84.5929C84.5996 75.2397 84.6407 75.3503 84.7161 75.4459C84.7932 75.5397 84.8955 75.6127 85.0229 75.6646C85.1503 75.7166 85.2936 75.7426 85.4528 75.7426C85.6187 75.7426 85.7654 75.7132 85.8928 75.6546C86.0202 75.5959 86.1199 75.5146 86.192 75.4107C86.2641 75.3068 86.3001 75.1869 86.3001 75.0511C86.3001 74.9137 86.2616 74.7922 86.1845 74.6866C86.109 74.5793 86.0001 74.4955 85.8576 74.4352C85.7168 74.3748 85.5492 74.3446 85.3548 74.3446H84.8745V73.5451H85.3548C85.519 73.5451 85.664 73.5166 85.7897 73.4596C85.9171 73.4026 86.016 73.3239 86.0864 73.2233C86.1568 73.121 86.192 73.002 86.192 72.8663C86.192 72.7372 86.161 72.6241 86.099 72.5268C86.0386 72.4279 85.9531 72.3508 85.8425 72.2955C85.7336 72.2402 85.6062 72.2126 85.4603 72.2126C85.3128 72.2126 85.1779 72.2394 85.0556 72.293C84.9332 72.345 84.8351 72.4196 84.7614 72.5168C84.6876 72.614 84.6482 72.728 84.6432 72.8587H83.5998C83.6048 72.562 83.6895 72.3006 83.8537 72.0743C84.018 71.848 84.2393 71.6712 84.5175 71.5438C84.7974 71.4147 85.1134 71.3502 85.4654 71.3502C85.8207 71.3502 86.1317 71.4147 86.3982 71.5438C86.6647 71.6728 86.8717 71.8472 87.0192 72.0667C87.1684 72.2846 87.2421 72.5293 87.2404 72.8009C87.2421 73.0892 87.1524 73.3297 86.9714 73.5225C86.7921 73.7152 86.5582 73.8376 86.2699 73.8896V73.9298C86.6488 73.9784 86.9371 74.11 87.1348 74.3245C87.3343 74.5374 87.4332 74.8039 87.4315 75.1241C87.4332 75.4174 87.3486 75.678 87.1776 75.906C87.0083 76.1339 86.7745 76.3133 86.4761 76.444C86.1777 76.5748 85.8358 76.6401 85.4503 76.6401Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M66.7675 76.5697V75.7853L68.6004 74.0882C68.7563 73.9373 68.887 73.8016 68.9926 73.6809C69.0999 73.5602 69.1812 73.442 69.2365 73.3264C69.2918 73.209 69.3195 73.0825 69.3195 72.9467C69.3195 72.7959 69.2851 72.666 69.2164 72.557C69.1477 72.4464 69.0538 72.3617 68.9348 72.3031C68.8158 72.2427 68.6809 72.2126 68.53 72.2126C68.3724 72.2126 68.235 72.2444 68.1177 72.3081C68.0003 72.3718 67.9098 72.4631 67.8461 72.5821C67.7824 72.7012 67.7506 72.8428 67.7506 73.0071H66.7172C66.7172 72.6701 66.7935 72.3777 66.946 72.1296C67.0986 71.8815 67.3123 71.6896 67.5872 71.5538C67.8621 71.4181 68.1788 71.3502 68.5375 71.3502C68.9063 71.3502 69.2273 71.4155 69.5005 71.5463C69.7754 71.6753 69.9891 71.8547 70.1416 72.0843C70.2942 72.314 70.3704 72.5771 70.3704 72.8738C70.3704 73.0682 70.3319 73.2602 70.2548 73.4496C70.1794 73.639 70.0444 73.8493 69.85 74.0806C69.6556 74.3103 69.3815 74.586 69.0278 74.9078L68.2761 75.6445V75.6797H70.4383V76.5697H66.7675Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSurveyFull);
export default __webpack_public_path__ + "static/media/survey_full.f2152b4e595e1d90e4d1b0d6166ed806.svg";
export { ForwardRef as ReactComponent };